import React, {
  ReactElement,
  Fragment,
} from 'react';
import { IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import Popover from '@mui/material/Popover';
import CloudDownloadRoundedIcon from '@mui/icons-material/CloudDownloadRounded';

export const MoreFileOptions = ({
  clickOnEdit,
  clickOnDelete,
  disabledDelete,
  clickOnDownload,
  hideEdit,
  hideDelete,
}: {
  clickOnEdit: () => void;
  clickOnDelete: () => void;
  clickOnDownload: () => void;
  disabledDelete?: boolean;
  hideEdit?: boolean;
  hideDelete?: boolean;
}): ReactElement => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <IconButton
        size={'small'}
        aria-label="more options"
        color={'default'}
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        onClick={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <IconButton
          onClick={() => {
            clickOnDownload();
          }}
        >
          <CloudDownloadRoundedIcon color={'primary'} />
        </IconButton>
        {!hideEdit && (
          <IconButton
            size={'small'}
            color={'primary'}
            aria-label="edit"
            onClick={() => {
              clickOnEdit();
            }}
          >
            <EditIcon />
          </IconButton>
        )}

        {!hideDelete && (
          <IconButton
            disabled={disabledDelete}
            size={'small'}
            aria-label="delete"
            onClick={() => {
              clickOnDelete();
            }}
            color={'error'}
          >
            <DeleteIcon />
          </IconButton>
        )}

      </Popover>
    </>
  );
};
